import { PositionUserRuleDictionaryItem } from '@/models/dictionary/positionUserRule';
import { useRemoteDictionaryHelpers } from '@/stores/utils/useRemoteDictionaryHelpers';
import { IPositionUserRuleDictionaryApi } from '@/types';

export const usePositionUserRuleDictionary = defineStore('positionUserRuleDictionary', () => {
    const itemsAll = shallowRef<PositionUserRuleDictionaryItem[]>([]);

    const { itemById, nameById } = useRemoteDictionaryHelpers(itemsAll);

    function setData(data: IPositionUserRuleDictionaryApi[]) {
        itemsAll.value = data.map((item) => new PositionUserRuleDictionaryItem(item));
    }

    const items = computed(() => itemsAll.value);

    return {
        items,
        itemById,
        nameById,
        setData,
    };
});
